import { render } from "./TextBox.vue?vue&type=template&id=bfeddeae&scoped=true"
import script from "./TextBox.vue?vue&type=script&lang=js"
export * from "./TextBox.vue?vue&type=script&lang=js"

import "./TextBox.vue?vue&type=style&index=0&id=bfeddeae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfeddeae"]])

export default __exports__